<template lang="pug">
.relative
    VueTimepicker.mr-10.relative(:format="format" v-model="currentTime"
    :disabled="isDisabled"
    :placeholder="$t('__c6N3.__pleaseSelectATime')"
    :class="{'borderVueTimepicker': error}" 
    @close="toBlur" @change="change" :hide-clear-button="true" :fixed-dropdown-button="true" :minute-interval="15")
      template(v-slot:dropdownButton)
        iCon.h-23.w-23.text-grey-b4.absolute.top-5.right-5(:iconClass="icon" type="svg" v-if="icon ")
        //-   //&& !currentTime['HH'] 如果需要無資料才顯示的話
    .error.flex.items-center(v-show="error")
      small.text-error.pt-3 {{error}}
      //@input="inputHandler"s
</template>

<script>
import VueTimepicker from "vue2-timepicker";
// import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: "TimePicker",
  components: {
    VueTimepicker
  },
  props: {
    valueDatePicker: {
      type: undefined,
      required: true
    },
    format: {
      type: String
    },
    error: String,
    isDisabled: Boolean,
    icon: {
      type: String,
      default: "Ico_Time"
    }
  },

  data() {
    return {
      isShow: this.show
      // currentTime: '',
    };
  },
  mounted() {
    this.isShow = this.show;
  },
  methods: {
    toBlur() {
      this.$emit("toBlur", this.currentTime);
    },
    inputHandler(e) {
      this.$emit("changeTime", e);
    },
    change() {}
  },
  watch: {
    valueDatePicker: {
      handler: function(n) {},
      deep: true
    }
  },
  computed: {
    currentTime: {
      get() {
        if (this.valueDatePicker) {
          if (this.valueDatePicker["HH"]) {
            return this.valueDatePicker;
          } else {
            return { HH: null, mm: null };
          }
        } else {
          return { HH: null, mm: null };
        }
      },
      set(val) {
        this.$emit("changeTime", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
